import { lazy, Suspense } from "react";
import { Loading } from "components/common/Loading";

export const Loadable = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );

// AUTH
const AuthLogin = Loadable(lazy(() => import("pages/auth/login")));
const ResetPassword = Loadable(lazy(() => import("pages/auth/resetPassword")));
const ForgetPassword = Loadable(
  lazy(() => import("pages/auth/forgetPassword"))
);

// HOME
const Home = Loadable(lazy(() => import("pages/home")));

// PROFILE
const Profile = Loadable(lazy(() => import("pages/profile")));

// SETTINS
const Settings = Loadable(lazy(() => import("pages/settings")));

// NOTIFICATIONS
const Notifications = Loadable(lazy(() => import("pages/notifications")));

// CALENDAR
const Calendar = Loadable(lazy(() => import("pages/calendar/calendar")));

// APPLICATIONS
const ApplicationsList = Loadable(
  lazy(() => import("pages/applications/list"))
);
const ApplicationsLeave = Loadable(
  lazy(() => import("pages/applications/leave"))
);
const ApplicationsLoan = Loadable(
  lazy(() => import("pages/applications/loan"))
);
const ApplicationsSalaryAllowance = Loadable(
  lazy(() => import("pages/applications/salaryAllowance"))
);
const ApplicationsMission = Loadable(
  lazy(() => import("pages/applications/mission"))
);
const ApplicationOvertime = Loadable(
  lazy(() => import("pages/applications/overtime"))
);
const ApplicationsCertificate = Loadable(
  lazy(() => import("pages/applications/certificate"))
);
const ApplicationsDetails = Loadable(
  lazy(() => import("pages/applications/details"))
);
const EmployeeActionWarning = Loadable(
  lazy(() => import("pages/applications/employeeActionWarning"))
);
const EmployeeActionAppreciation = Loadable(
  lazy(() => import("pages/applications/employeeActionAppreciation"))
);
const EmployeeActionList = Loadable(
  lazy(() => import("pages/applications/employeeActionList"))
);

// APPROVALS
const PendingActionsList = Loadable(lazy(() => import("pages/pending/list")));
const PendingActionsApprove = Loadable(
  lazy(() => import("pages/pending/approve"))
);

// MESSAGES
const MessagesList = Loadable(lazy(() => import("pages/messages/list")));
const MessageDetail = Loadable(lazy(() => import("pages/messages/detail")));

// DASHBOARD
const Dashboard = Loadable(lazy(() => import("pages/dashboard")));

// TEAM STATISTICS
const TeamStatistics = Loadable(lazy(() => import("pages/team-statistics")));

// LEAVE HEATMAP
const LeaveHeatmap = Loadable(lazy(() => import("pages/leave-heatmap")));

// PUBLIC CALENDAR
const PublicCalendar = Loadable(lazy(() => import("pages/public-calendar")));

// MEETING ROOM
const MeetingRoom = Loadable(lazy(() => import("pages/meeting-room")));

// ANNOUNCEMENTS
const AnnouncementsList = Loadable(lazy(() => import("pages/announcements/list")));
const AnnouncementsCreate = Loadable(lazy(() => import("pages/announcements/create")));
const AnnouncementsDetail = Loadable(lazy(() => import("pages/announcements/detail")));

// SURVEYS
const SurveysList = Loadable(lazy(() => import("pages/surveys/list")));
const SurveysCreate = Loadable(lazy(() => import("pages/surveys/create")));
const SurveysDetail = Loadable(lazy(() => import("pages/surveys/detail")));
const SurveysSubmit = Loadable(lazy(() => import("pages/surveys/submit")));
const SurveysResults = Loadable(lazy(() => import("pages/surveys/results")));

// ATTENDANCE
const AttendanceToday = Loadable(lazy(() => import("pages/attendance/today")));
const AttendanceReport = Loadable(lazy(() => import("pages/attendance/report")));
const AttendanceTeamToday = Loadable(lazy(() => import("pages/attendance/team-today")));
const AttendanceTeamReport = Loadable(lazy(() => import("pages/attendance/team-report")));

// TRAINING
const TrainingList = Loadable(lazy(() => import("pages/training/list")));
const TrainingCreate = Loadable(lazy(() => import("pages/training/create")));
const TrainingDetail = Loadable(lazy(() => import("pages/training/detail")));
const TrainingMyEnrollments = Loadable(lazy(() => import("pages/training/my-enrollments")));

// USERS (ADMIN)
const UsersList = Loadable(lazy(() => import("pages/users/list")));
const UsersCreate = Loadable(lazy(() => import("pages/users/create")));

const NotFound = Loadable(lazy(() => import("pages/404")));

export {
  AuthLogin,
  ForgetPassword,
  ResetPassword,
  ApplicationsList,
  ApplicationsLeave,
  ApplicationsLoan,
  ApplicationsMission,
  ApplicationsCertificate,
  ApplicationsDetails,
  ApplicationOvertime,
  EmployeeActionWarning,
  EmployeeActionAppreciation,
  EmployeeActionList,
  Home,
  Profile,
  Settings,
  Notifications,
  Calendar,
  ApplicationsSalaryAllowance,
  PendingActionsList,
  PendingActionsApprove,
  MessagesList,
  MessageDetail,
  Dashboard,
  TeamStatistics,
  LeaveHeatmap,
  PublicCalendar,
  MeetingRoom,
  AnnouncementsList,
  AnnouncementsCreate,
  AnnouncementsDetail,
  SurveysList,
  SurveysCreate,
  SurveysDetail,
  SurveysSubmit,
  SurveysResults,
  AttendanceToday,
  AttendanceReport,
  AttendanceTeamToday,
  AttendanceTeamReport,
  TrainingList,
  TrainingCreate,
  TrainingDetail,
  TrainingMyEnrollments,
  UsersList,
  UsersCreate,
  NotFound,
};
